import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import DetailsList from '../DetailsList';

const PermissionSearchList = ({ items, className: classNameProp, ...other }) => {
  const className = clsx(classNameProp);

  return (
    <DetailsList
      items={items.map((item, index) => ({
        ...item,
        key: index,
      }))}
      className={className}
      {...other}
    />
  );
};

PermissionSearchList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  className: PropTypes.string,
};

PermissionSearchList.defaultProps = {
  items: [],
  className: '',
};

export default PermissionSearchList;
